/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query LBRRouteReadQuery($routeId: ID) {
  LBRRouteRead(routeId: $routeId) {
    id,
    displayName,
    type,
    CustomerAccount {
      id
      displayName
    }
  }
}
`
